import { render, staticRenderFns } from "./RemoveCircleIcon.vue?vue&type=template&id=45bec36a"
import script from "./RemoveCircleIcon.vue?vue&type=script&lang=ts"
export * from "./RemoveCircleIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45bec36a')) {
      api.createRecord('45bec36a', component.options)
    } else {
      api.reload('45bec36a', component.options)
    }
    module.hot.accept("./RemoveCircleIcon.vue?vue&type=template&id=45bec36a", function () {
      api.rerender('45bec36a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/RemoveCircleIcon.vue"
export default component.exports